"use client";

import { useEffect } from "react";

/**
 * Fetches user IP once and stores in localStorage.
 * Mounted in root layout so IP is available before any search page loads.
 * Skips fetch if IP is already stored (within 24hr TTL).
 */
const IpFetcher = () => {
  useEffect(() => {
    const storedIp = localStorage.getItem("user_ip");
    const storedAt = localStorage.getItem("user_ip_ts");
    const ONE_DAY = 24 * 60 * 60 * 1000;

    // Skip if we have a fresh IP (less than 24 hours old)
    if (storedIp && storedAt && Date.now() - Number(storedAt) < ONE_DAY) {
      return;
    }

    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => {
        if (data.ip) {
          localStorage.setItem("user_ip", data.ip);
          localStorage.setItem("user_ip_ts", String(Date.now()));
        }
      })
      .catch(() => {});
  }, []);

  return null;
};

export default IpFetcher;
